export const STAGIAIRE_LOGIN_REQUEST = 'STAGIAIRE_LOGIN_REQUEST'
export const STAGIAIRE_LOGIN_SUCCESS = 'STAGIAIRE_LOGIN_SUCCESS'
export const STAGIAIRE_LOGIN_FAIL = 'STAGIAIRE_LOGIN_FAIL'
export const STAGIAIRE_LOGOUT = 'STAGIAIRE_LOGOUT'

export const STAGIAIRE_REGISTER_REQUEST = 'STAGIAIRE_REGISTER_REQUEST'
export const STAGIAIRE_REGISTER_SUCCESS = 'STAGIAIRE_REGISTER_SUCCESS'
export const STAGIAIRE_REGISTER_FAIL = 'STAGIAIRE_REGISTER_FAIL'

export const STAGIAIRE_ADD_REQUEST = 'STAGIAIRE_REGISTER_REQUEST'
export const STAGIAIRE_ADD_SUCCESS = 'STAGIAIRE_REGISTER_SUCCESS'
export const STAGIAIRE_ADD_FAIL = 'STAGIAIRE_REGISTER_FAIL'

export const STAGIAIRE_DETAILS_REQUEST = 'STAGIAIRE_DETAILS_REQUEST'
export const STAGIAIRE_DETAILS_SUCCESS = 'STAGIAIRE_DETAILS_SUCCESS'
export const STAGIAIRE_DETAILS_FAIL = 'STAGIAIRE_DETAILS_FAIL'
export const STAGIAIRE_DETAILS_RESET = 'STAGIAIRE_DETAILS_RESET'

export const STAGIAIRE_UPDATE_PROFILE_REQUEST = 'STAGIAIRE_UPDATE_PROFILE_REQUEST'
export const STAGIAIRE_UPDATE_PROFILE_SUCCESS = 'STAGIAIRE_UPDATE_PROFILE_SUCCESS'
export const STAGIAIRE_UPDATE_PROFILE_FAIL = 'STAGIAIRE_UPDATE_PROFILE_FAIL'

export const STAGIAIRE_LIST_REQUEST = 'STAGIAIRE_LIST_REQUEST'
export const STAGIAIRE_LIST_SUCCESS = 'STAGIAIRE_LIST_SUCCESS'
export const STAGIAIRE_LIST_FAIL = 'STAGIAIRE_LIST_FAIL'
export const STAGIAIRE_LIST_RESET = 'STAGIAIRE_LIST_RESET'

export const STAGIAIRE_DELETE_REQUEST = 'STAGIAIRE_DELETE_REQUEST'
export const STAGIAIRE_DELETE_SUCCESS = 'STAGIAIRE_DELETE_SUCCESS'
export const STAGIAIRE_DELETE_FAIL = 'STAGIAIRE_DELETE_FAIL'

export const STAGIAIRE_UPDATE_REQUEST = 'STAGIAIRE_UPDATE_REQUEST'
export const STAGIAIRE_UPDATE_SUCCESS = 'STAGIAIRE_UPDATE_SUCCESS'
export const STAGIAIRE_UPDATE_FAIL = 'STAGIAIRE_UPDATE_FAIL'
export const STAGIAIRE_UPDATE_RESET = 'STAGIAIRE_UPDATE_RESET'
